var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCutwiseDrive = function SvgCutwiseDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 28a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.384 12.796A4 4 0 0 1 11.2 10H36.8a4 4 0 0 1 3.815 2.796l5.338 16.903L45 30a7 7 0 0 1-7 7H10a7 7 0 0 1-7-7l-.954-.301zm31.325.602A2 2 0 0 0 36.8 12H11.2a2 2 0 0 0-1.908 1.398L5.823 24.383A6.97 6.97 0 0 1 10 23h28c1.566 0 3.011.514 4.177 1.383zM38 25H10a5 5 0 0 0 0 10h28a5 5 0 0 0 0-10"
  })));
};
export default SvgCutwiseDrive;